<template>
  <div class="invite-tab-root" :class="[$i18n.locale === 'ar' ? 'ar-style' : '', packageName]">
    <div class="invite-search right-read">
      <input v-model="hostId" :placeholder="$t('lang.invite.inputPlaceholder')" />
      <img src="../images/search.png" alt="" @click="handleSearch" />
    </div>

    <!-- Learn more -->
    <div v-if="info.actInviteBeanReward && info.actInviteStartTimeStamp && info.actInviteEndTimeStamp" @click="handleLearnMore" class="invite-card right-read">
      <!-- <p class="card-info">Get extra 1000 <img :src="getMatchImg('beans')" /> for each friend invited</p> -->
      <MyPLabel class="card-info" :str="$t('lang.newInvite.k010')" :numsOption="[{ value: info.actInviteBeanReward, style: '' }]" :customClass="{ bean: 'invite-bean' }" />

      <div class="card-bottom">
        <div class="date-interval">{{ handleMoment(info.actInviteStartTimeStamp, 'DD/MM/YYYY') }} - {{ handleMoment(info.actInviteEndTimeStamp, 'DD/MM/YYYY') }}</div>
        <button class="learn-more">{{ $t('lang.newInvite.k011') }}</button>
      </div>
    </div>

    <div class="invite-list right-read">
      <div class="switch-tab">
        <div class="tab" :class="{ 'active-tab': inviteTabIndex == 0 }" @click="handelInviteTab(0)">{{ $t('lang.all') }}</div>
        <div class="tab" :class="{ 'active-tab': inviteTabIndex == 1 }" @click="handelInviteTab(1)">{{ $t('lang.dl.thisWeek') }}</div>
        <div class="tab" :class="{ 'active-tab': inviteTabIndex == 2 }" @click="handelInviteTab(2)">{{ $t('lang.host.lastWeek') }}</div>
      </div>

      <div class="amount-block" id="invite-target-aa">
        <div class="amount-item">
          <div class="amount-title">{{ $t('lang.dl.totalHostess') }}</div>
          <span class="amount-count">{{ totalHostess }}</span>
        </div>

        <div class="amount-item">
          <div class="amount-title">{{ $t('lang.inRule.inviteBonus') }}</div>
          <span class="amount-count">
            <img :src="getMatchImg('beans')" />
            {{ inviteBonus }}
          </span>
        </div>

        <div class="deliver-line"></div>
      </div>

      <!-- 新手指导节点 -->
      <template v-if="newGuyGuide.show">
        <div class="info-card">
          <img class="avatar-left" :src="imgPath" />
          <div class="info-right">
            <div class="text-row">
              <span class="text-left">
                Elizabeth
                <img class="country-icon" :src="imgPath" />
              </span>
              <span class="text-right">{{ $t('lang.newInvite.k049') }}</span>
            </div>
            <div class="num-row">
              <span class="num-left">
                ID: 100040
                <img class="copy-icon" src="../images/copy-gray.png" />
              </span>
              <span class="num-left">30/04/2025</span>
            </div>
          </div>
        </div>

        <div class="status-item" id="invite-target-ab">
          <div class="status-line"></div>
          <div class="status-card">
            <div>
              <div class="status-step">
                <div class="step-icon">
                  <img src="../images/status-step1.png" />
                </div>

                <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                <img v-else class="status-icon" src="../images/status-done.png" alt="" />
              </div>
            </div>
            <div class="status-step">
              <div class="step-icon">
                <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" />
                <img v-else src="../images/status-step2.png" />
              </div>
              <!-- <img class="status-icon" src="../images/status-fail.png" alt="" /> -->
              <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
              <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
              <span class="beans-num">
                200
                <img :src="getMatchImg('beans-off')" />
              </span>
              <!-- <span class="beans-num active">200 <img :src="getMatchImg('beans')"/></span> -->
            </div>
            <div>
              <div class="status-step">
                <div class="step-icon">
                  <img :src="getMatchImg('beans')" />
                </div>
                <img class="status-icon" src="../images/status-fail.png" alt="" />
                <span class="beans-num underline">
                  1000
                  <img :src="getMatchImg('beans-off')" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 实际渲染节点 -->
      <div class="van-clearfix" v-for="(item, index) in hosts" :key="index">
        <div class="info-card">
          <img class="avatar-left" :src="item.avatar | imgPath" />
          <div class="info-right">
            <div class="text-row">
              <span class="text-left">
                {{ item.nickname }}
                <img class="country-icon" :src="item.locationFlag | imgPath" />
              </span>
              <span class="text-right">{{ $t('lang.newInvite.k049') }}</span>
            </div>
            <div class="num-row">
              <span class="num-left" @click="handleCopyId(item)">
                ID: {{ item.presentId }}
                <img class="copy-icon" src="../images/copy-gray.png" />
              </span>
              <span class="num-left">{{ handleMoment(item.createTime, 'DD/MM/YYYY') }}</span>
            </div>
          </div>
        </div>

        <div class="status-item" v-if="item.ifShowTaskProcess">
          <div class="status-line"></div>
          <!-- verified -->
          <div class="status-card" :style="`justify-content: ${item.activityTaskState ? 'space-around' : 'space-between'}`">
            <div>
              <div class="status-step">
                <div class="step-icon" @click.stop="showTips($event, item.verifiedTip)">
                  <img src="../images/status-step1.png" />
                </div>

                <!-- 状态图标 -->
                <template v-if="item.verifyState === 1">
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-done.png" alt="" />
                </template>
                <template v-if="item.verifyState === 2">
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
                </template>
                <img v-if="item.verifyState === 3" class="status-icon" src="../images/status-fail.png" alt="" />
              </div>
            </div>

            <!-- common -->
            <!-- 第三步activity存在 -->
            <div v-if="item.activityTaskState" class="status-step">
              <div class="step-icon" @click.stop="showTips($event, item.commonTaskTip)">
                <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" />
                <img v-else src="../images/status-step2.png" />
              </div>

              <!-- 状态图标 -->
              <template v-if="item.commonTaskState === 1">
                <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                <img v-else class="status-icon" src="../images/status-done.png" alt="" />
                <span class="beans-num highline">
                  {{ item.commRewardBeans }}
                  <img :src="getMatchImg('beans')" />
                </span>
              </template>

              <template v-if="item.commonTaskState === 2">
                <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
                <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
                <span class="beans-num">
                  {{ item.commRewardBeans }}
                  <img :src="getMatchImg('beans-off')" />
                </span>
              </template>

              <template v-if="item.commonTaskState === 3">
                <img class="status-icon" src="../images/status-fail.png" alt="" />
                <span class="beans-num underline">
                  {{ item.commRewardBeans }}
                  <img :src="getMatchImg('beans-off')" />
                </span>
              </template>
            </div>

            <!-- 第三步activity不存在 -->
            <div v-else>
              <div class="status-step">
                <div class="step-icon" @click.stop="showTips($event, item.commonTaskTip)">
                  <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" />
                  <img v-else src="../images/status-step2.png" />
                </div>

                <!-- 状态图标 -->
                <template v-if="item.commonTaskState === 1">
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-done.png" alt="" />
                  <span class="beans-num highline">
                    {{ item.commRewardBeans }}
                    <img :src="getMatchImg('beans')" />
                  </span>
                </template>

                <template v-if="item.commonTaskState === 2">
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
                  <span class="beans-num">
                    {{ item.commRewardBeans }}
                    <img :src="getMatchImg('beans-off')" />
                  </span>
                </template>

                <template v-if="item.commonTaskState === 3">
                  <img class="status-icon" src="../images/status-fail.png" alt="" />
                  <span class="beans-num underline">
                    {{ item.commRewardBeans }}
                    <img :src="getMatchImg('beans-off')" />
                  </span>
                </template>
              </div>
            </div>

            <!-- activity -->
            <div v-if="item.activityTaskState">
              <div class="status-step">
                <div class="step-icon" @click.stop="showTips($event, item.activityTaskTip)">
                  <img :src="getMatchImg('beans')" />
                </div>

                <!-- 状态图标 -->
                <template v-if="item.activityTaskState === 1">
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-done.png" alt="" />
                </template>

                <template v-if="item.activityTaskState === 2">
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
                </template>

                <template v-if="item.activityTaskState === 3">
                  <img class="status-icon" src="../images/status-fail.png" alt="" />
                </template>

                <!-- 文案 -->
                <template v-if="item.activityTaskState === 1">
                  <span class="beans-num highline">
                    {{ item.activityRewardBeans }}
                    <img :src="getMatchImg('beans')" />
                  </span>
                </template>

                <template v-if="item.activityTaskState === 2">
                  <span class="beans-num">
                    {{ item.activityRewardBeans }}
                    <img :src="getMatchImg('beans-off')" />
                  </span>
                </template>

                <template v-if="item.activityTaskState === 3">
                  <span class="beans-num underline">
                    {{ item.activityRewardBeans }}
                    <img :src="getMatchImg('beans-off')" />
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="is-loading">
        <van-loading size="24px" />
      </div>

      <div v-if="finished" class="no-more">{{ $t('lang.noMore') }}</div>

      <InviteSearch :showDia="showSearchDia" :hostDate="searchHostData" />

      <ConfirmAuto
        :showDia="removeConfirmAutoDia"
        :title="removeTitle"
        :content="removeContent"
        :leftBtnText="leftBtnText"
        :rightBtnText="rightBtnText"
        @leftBtn="removeLeftBtn"
        @rightBtn="removeRightBtn"
      />

      <TipOnclick v-if="tipsInfo.show" :position="tipsInfo.position" :text="tipsInfo.text" :direction="tipsInfo.direction" />

      <!-- step1 -->
      <div class="newguy-guide" id="guide-step1" @click="handleGuideClick(1)">
        <div class="step3">
          <div class="newguy-guide-tips">
            <div class="tips-content">
              <div class="tips-title right-align">{{ $t('lang.newInvite.k044') }}</div>
            </div>
          </div>

          <div class="amount-block" id="invite-guide-aa">
            <div class="amount-item">
              <div class="amount-title">{{ $t('lang.dl.totalHostess') }}</div>
              <span class="amount-count">10</span>
            </div>

            <div class="amount-item">
              <div class="amount-title">{{ $t('lang.inRule.inviteBonus') }}</div>
              <span class="amount-count">
                <img :src="getMatchImg('beans')" />
                2000
              </span>
            </div>

            <div class="deliver-line"></div>
          </div>

          <div class="btn-wrap">
            <div class="newguy-guide-btn">
              <div @click="handleGuideClick(1)">{{ $t('lang.newInvite.k050') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- step2 -->
      <div class="newguy-guide" id="guide-step2" @click="handleGuideClick(2)">
        <div class="step1AndStep2">
          <div class="btn-wrap">
            <div class="newguy-guide-btn">
              <div @click.self="handleGuideClick(2)">{{ $t('lang.newInvite.k050') }}</div>
            </div>
          </div>

          <div class="newguy-guide-tips">
            <div class="tips-content">
              <p class="tips-title">{{ $t('lang.newInvite.k036') }}</p>
              <div class="tips-item">
                <img src="../images/status-step1.png" alt="" />
                {{ $t('lang.newInvite.k037') }}
              </div>
              <div class="tips-item">
                <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" />
                <img v-else src="../images/status-step2.png" />
                {{ $t('lang.newInvite.k038') }}
              </div>
              <div class="tips-item">
                <img :src="getMatchImg('beans')" alt="" />
                {{ $t('lang.newInvite.k039') }}
              </div>
            </div>
          </div>

          <div class="status-item" id="invite-guide-ab">
            <div class="status-line"></div>
            <div class="status-card">
              <div>
                <div class="status-step">
                  <div class="step-icon">
                    <img src="../images/status-step1.png" />
                  </div>
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-done.png" alt="" />
                </div>
              </div>
              <div class="status-step">
                <div class="step-icon">
                  <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" />
                  <img v-else src="../images/status-step2.png" />
                </div>
                <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
                <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
                <span class="beans-num">
                  200
                  <img :src="getMatchImg('beans-off')" />
                </span>
              </div>
              <div>
                <div class="status-step">
                  <div class="step-icon">
                    <img :src="getMatchImg('beans')" />
                  </div>
                  <img class="status-icon" src="../images/status-fail.png" alt="" />
                  <span class="beans-num underline">
                    1000
                    <img :src="getMatchImg('beans-off')" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- step3 -->
      <div class="newguy-guide" id="guide-step3" @click="handleGuideClick(3)">
        <div class="step1AndStep2">
          <div class="btn-wrap">
            <div class="newguy-guide-btn">
              <div @click="handleGuideClick(3)">{{ $t('lang.newInvite.k050') }}</div>
            </div>
          </div>

          <div class="newguy-guide-tips">
            <div class="tips-content">
              <p class="tips-title">{{ $t('lang.newInvite.k040') }}</p>
              <div class="tips-item">
                <img v-if="packageName === 'kiko'" src="../images/status-done-kiko.png" alt="" />
                <img v-else src="../images/status-done.png" alt="" />
                {{ $t('lang.newInvite.k041') }}
              </div>
              <div class="tips-item">
                <img v-if="packageName === 'kiko'" src="../images/status-checking-kiko.png" alt="" />
                <img v-else src="../images/status-checking.png" alt="" />
                {{ $t('lang.newInvite.k042') }}
              </div>
              <div class="tips-item">
                <img src="../images/status-fail.png" alt="" />
                {{ $t('lang.newInvite.k043') }}
              </div>
            </div>
          </div>

          <div class="status-item" id="invite-guide-bb">
            <div class="status-line"></div>
            <div class="status-card">
              <div>
                <div class="status-step">
                  <div class="step-icon">
                    <img src="../images/status-step1.png" />
                  </div>
                  <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-done-kiko.png" alt="" />
                  <img v-else class="status-icon" src="../images/status-done.png" alt="" />
                </div>
              </div>
              <div class="status-step">
                <div class="step-icon">
                  <img v-if="packageName === 'kiko'" src="../images/status-step2-kiko.png" />
                  <img v-else src="../images/status-step2.png" />
                </div>
                <img v-if="packageName === 'kiko'" class="status-icon" src="../images/status-checking-kiko.png" alt="" />
                <img v-else class="status-icon" src="../images/status-checking.png" alt="" />
                <span class="beans-num">
                  200
                  <img :src="getMatchImg('beans-off')" />
                </span>
              </div>
              <div>
                <div class="status-step">
                  <div class="step-icon">
                    <img :src="getMatchImg('beans')" />
                  </div>
                  <img class="status-icon" src="../images/status-fail.png" alt="" />
                  <span class="beans-num underline">
                    1000
                    <img :src="getMatchImg('beans-off')" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 450px"></div>
  </div>
</template>

<script>
import { apiSearchAgent, apiDeleteAgent } from '@/api/invite'
import { apiFetchMyInvite } from '@/api/imee'
import { tabEnmu } from '../utils/enum'

import eventBus from '@/utils/eventbus'

import InviteSearch from './InviteSearch'
import CConfirmAuto from '@/components/CConfirmAuto'
import TipOnclick from '@/components/TipOnclick/index.vue'

export default {
  name: 'InviteTab',
  components: { InviteSearch, ConfirmAuto: CConfirmAuto, TipOnclick },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      }
    }
  },
  data() {
    let query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      inviteTabIndex: 0,
      listQuery: {
        limit: 5,
        offset: 0
      },
      loading: false,
      finished: false,
      hosts: [],
      totalHostess: 0,
      inviteBonus: 0,
      // search
      hostId: '',
      showSearchDia: false,
      searchHostData: null,
      // 移除弹窗按钮
      removeConfirmAutoDia: false,
      removeTitle: this.$t('lang.removeCfm.removeTit'),
      removeContent1: this.$t('lang.removeCfm.removeCon1'),
      removeContent2: this.$t('lang.removeCfm.removeCon2'),
      leftBtnText: this.$t('lang.cfm.removeBtn'),
      rightBtnText: this.$t('lang.cfm.cancelBtn'),
      // tips参数
      tipsInfo: {
        show: false,
        position: {
          left: '',
          top: ''
        },
        text: '',
        direction: ''
      }
    }
  },
  computed: {
    removeContent() {
      const getMatchColor = {
        default: '#a338fc',
        kiko: '#ff8a33'
      }

      let colorVal = getMatchColor[this.packageName] || 'default'

      return `${this.removeContent1}<i style="color:${colorVal}">ID${this.hostId} </i>${this.removeContent2}`
    }
  },
  inject: ['newGuyGuide'],
  methods: {
    // 处理阿语方向 - popover方向
    reDirection(direction, isAr) {
      const dirMap = {
        left: 'right',
        right: 'left'
      }
      if (isAr) {
        return dirMap[direction]
      }
      return direction
    },
    handleLearnMore() {
      window.sessionStorage.setItem('inviteV2Tabindex', tabEnmu.invite)
      this.$router.push({ path: '/invite-v2-rules', query: { fromPage: 'invite-v2', location: 'limitedBonus' } })
    },
    handleGuideClick(arg) {
      this.$emit('stepChange', `step${arg + 1}`)
    },
    handleCopyId(item) {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.handleCopy(item.presentId, this.$t('lang.msgCopySuccss'))
    },
    //获取 Invite 数据 All
    fetchMyInvite(val) {
      this.loading = true
      let params = {
        timeType: val,
        ...this.listQuery
      }
      apiFetchMyInvite(params).then((res) => {
        if (res && !res.error) {
          if (params.timeType === this.inviteTabIndex) {
            this.totalHostess = res.total || 0
            this.inviteBonus = res.inviteBonusBeans || 0
            this.hosts = this.hosts.concat(res.hosts || [])
            this.listQuery.offset = this.hosts.length

            this.loading = false
            this.finished = (res.hosts || []).length < this.listQuery.limit

            if (!this.finished) {
              this.$parent.nativeScroll && this.$parent.nativeScroll.finishPullUp()
            }

            // 刷新better
            this.$nextTick(() => {
              this.$parent.nativeScroll && this.$parent.nativeScroll.refresh()
            })
          }
          // 非当前tab
          else {
            this.loading = false
          }
        }
      })
    },
    handelInviteTab(arg) {
      this.inviteTabIndex = arg
      this.hosts = []
      this.loading = false
      this.finished = false
      this.listQuery.limit = 10
      this.listQuery.offset = 0
      this.fetchMyInvite(this.inviteTabIndex)
    },
    // 获取主播列表
    getHosts() {
      this.fetchMyInvite(this.inviteTabIndex)
    },
    // 搜素主播账号
    handleSearch() {
      if (this.hostId) {
        apiSearchAgent(this.hostId).then((res) => {
          if (res && res.uid) {
            this.searchHostData = res
            this.showSearchDia = true
          }
        })
      }
    },
    // 移除主播相关
    closeSearchDia() {
      this.showSearchDia = false
    },
    // 打开移除二次确认弹窗
    removeBtn() {
      this.showSearchDia = false
      this.removeConfirmAutoDia = true
    },

    // 移除代理二次确认左右按钮
    removeLeftBtn() {
      if (this.hostId) {
        apiDeleteAgent(this.hostId).then((res) => {
          if (res) {
            this.removeConfirmAutoDia = false
            this.hosts = []
            this.listQuery.limit = 10
            this.listQuery.offset = 0
            this.hostId = null
            this.fetchMyInvite(this.inviteTabIndex)
          }
        })
      }
    },
    removeRightBtn() {
      this.removeConfirmAutoDia = false
    },
    scrollEvent(arg) {
      if (arg.type === 'arriveBottom') {
        this.fetchMyInvite(this.inviteTabIndex)
        return
      }
      if (arg.type === 'scroll') {
        this.hideTips()
      }
    },
    showTips(e, text) {
      const screenW = document.body.clientWidth
      const leftLimit = screenW / 3
      const rightLimit = leftLimit * 2

      let left = e.x
      let top = e.y - 14
      let dir = 'top'
      if (e.x < leftLimit) {
        dir = 'top-left'
        left = left - 14
      }
      if (e.x > leftLimit && e.x < rightLimit) {
        dir = 'top'
      }
      if (e.x > rightLimit) {
        dir = 'top-right'
        left = left + 14
      }

      this.tipsInfo.position.left = `${left}px`
      this.tipsInfo.position.top = `${top}px`
      this.tipsInfo.text = text
      this.tipsInfo.direction = dir
      this.tipsInfo.show = true
    },
    hideTips() {
      this.tipsInfo.show = false
      this.tipsInfo.position.left = ''
      this.tipsInfo.position.top = ''
      this.tipsInfo.text = ''
      this.tipsInfo.direction = ''
    }
  },
  created() {
    eventBus.$on('InviteScroll', this.scrollEvent)
    this.handelInviteTab(1)
    document.body.addEventListener('click', this.hideTips)
  },
  beforeDestroy() {
    eventBus.$off('InviteScroll', this.scrollEvent)
    document.body.removeEventListener('click', this.hideTips)
  }
}
</script>

<!-- vava echo joychat -->
<style lang="scss" scoped>
.invite-tab-root {
  .invite-search {
    width: 343px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    margin: 16px auto 0;
    display: flex;
    align-items: center;
    padding: 0 6px 0 12px;

    input {
      display: inline-block;
      height: 100%;
      flex: 1;
      font-size: 16px;
      &::placeholder {
        font-family: HindMadurai;
        font-weight: 400;
        font-size: 13px;
        color: #cdcdd4;
      }
    }

    img {
      width: 18px;
      height: 18px;
      box-sizing: content-box;
      border: 6px solid transparent;
    }
  }

  .invite-card {
    width: 343px;
    min-height: 96px;
    margin: 16px auto 0;
    background: #3b1581;
    border-radius: 4px;
    overflow: hidden;
    padding: 20px 12px 12px;

    .card-info {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 17px;
      color: #ffffff;
      line-height: 20px;
      letter-spacing: -1px;
      img {
        display: inline-block;
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }
    }

    .card-bottom {
      display: flex;
      align-items: center;
      margin-top: 7px;
      .date-interval {
        flex: 1;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 16px;
      }
      .learn-more {
        width: 119px;
        height: 34px;
        background: #a338fc;
        border-radius: 24px;

        font-family: RobotoFlex;
        font-weight: normal;
        font-size: 15px;
        color: #ffffff;
        line-height: 34px;
      }
    }
  }

  .invite-list {
    width: 343px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 auto;
    padding-bottom: 12px;
    margin-top: 16px;
  }

  .switch-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 12px;
    background-color: #ffffff;
    .tab {
      min-height: 26px;
      padding: 0 10px 4px;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 17px;
      color: #b2b2b2;
      line-height: 20px;
      text-align: center;

      &.active-tab {
        color: #333333;
        position: relative;
        font-weight: bold;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 35px;
          height: 2px;
          margin-left: -17.5px;
          background-color: #333333;
        }
      }
    }
  }

  .amount-block {
    overflow: hidden;
  }

  .amount-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    margin-top: 16px;
    .amount-title {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
    }
    .amount-count {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #a338fc;
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }

  .deliver-line {
    width: 343px;
    height: 1px;
    background: #ededed;
    margin-top: 16px;
  }

  .info-card {
    display: flex;
    padding: 16px 12px 12px;
    justify-content: space-between;
    .avatar-left {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }
    .info-right {
      flex: 1;
      margin-left: 10px;
      .text-row {
        display: flex;
        justify-content: space-between;
        .text-left {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          img {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            vertical-align: middle;
            margin-left: 4px;
          }
          .country-icon {
            border: 0.5px solid rgba(102, 102, 102, 0.1);
          }
        }
        .text-right {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
        }
      }
      .num-row {
        display: flex;
        justify-content: space-between;
        margin-top: 4px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 12px;
        color: #b2b2b2;
        .num-left {
          img {
            width: 12px;
            height: 12px;
            vertical-align: middle;
            margin-left: 4px;
          }
        }
      }
    }
  }

  .status-item {
    width: 319px;
    background: #f8f8ff;
    margin: 0 auto;
    position: relative;
    .status-card {
      display: flex;
      justify-content: space-around;
      border-radius: 4px;
      padding: 0 18px 12px;
      position: relative;
      .status-step {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 12px;
        border-radius: 8px;
        .step-icon {
          display: block;
          width: 36px;
          height: 36px;
          background-color: #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 22px;
            height: 22px;
            line-height: 36px;
          }
        }
        .status-icon {
          box-sizing: content-box;
          display: block;
          width: 16px;
          height: 16px;
          border: 4px solid transparent;
          margin: auto;
        }
        .beans-num {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 12px;
          color: #b2b2b2;
          margin-top: 6px;
          display: flex;
          align-items: center;
          img {
            width: 13px;
            height: 13px;
            margin-left: 2px;
          }
          &.highline {
            color: #a338fc;
          }
          &.underline {
            text-decoration-line: line-through;
          }
        }
        &:first-child {
          flex: auto;
        }
      }
    }
    .status-line {
      width: 260px;
      height: 2px;
      background: #e7e7f6;
      border-radius: 1px;
      position: absolute;
      top: 29px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
    }
  }
  .newguy-guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    z-index: -999;

    .newguy-guide-btn {
      min-width: 72px;
      height: 30px;
      padding: 0 10px;
      border-radius: 20px;
      border: 1px solid #ffffff;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .newguy-guide-tips {
      width: 321px;
      background: #fdfdfd;
      border-radius: 8px;
      .tips-content {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 30px 22px;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -7px;
          z-index: -1;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background: #fdfdfd;
          transform: rotate(45deg);
        }
        .tips-title {
          height: 40px;
          margin: 0 auto;
          font-family: RobotoFlex;
          font-weight: normal;
          font-size: 17px;
          color: #333333;
          line-height: 20px;
          text-align: center;
        }

        .tips-item {
          display: flex;
          align-items: center;

          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          margin-top: 16px;
          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }
        }
      }
    }

    .step1AndStep2 {
      position: absolute;
      bottom: 44px;
      right: 27px;

      .btn-wrap {
        text-align: right;
      }

      .newguy-guide-tips {
        margin-top: 20px;
      }

      .status-item {
        margin-top: 20px;
        border-radius: 8px;
      }
    }

    .step3 {
      position: absolute;
      bottom: 155px;
      right: 50%;
      transform: translateX(50%);

      .newguy-guide-tips {
        width: 280px;
        margin: 0 auto;

        .tips-content {
          padding: 12px 20px;
          .tips-title {
            height: auto;
            margin: 0 auto;
            font-size: 15px;
            text-align: left;
            letter-spacing: -1px;
          }
        }
      }

      .amount-block {
        border-radius: 8px;
        z-index: 9999;
        background: #fdfdfd;
        margin-top: 20px;
      }

      .btn-wrap {
        text-align: center;
        margin-top: 20px;
      }
    }
  }

  .is-loading {
    padding-top: 10px;
    text-align: center;
  }

  .no-more {
    padding-top: 10px;
    text-align: center;
    color: #b2b2b2;
    font-size: 16px;
  }
}

.ar-style {
  .amount-item {
    .amount-count {
      img {
        margin-right: 0;
        margin-left: 4px;
      }
    }
  }

  .info-card {
    .info-right {
      margin-left: 0;
      margin-right: 10px;
      .text-row {
        .text-left {
          img {
            margin-right: 4px !important;
            margin-left: 0 !important;
          }
        }
      }
      .num-row {
        .num-left {
          img {
            margin-left: 0;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .newguy-guide-tips {
    .tips-item {
      img {
        margin-left: 10px;
        margin-right: auto;
      }
    }
  }
}
</style>

<!-- kiko -->
<style lang="scss" scoped>
.invite-tab-root.kiko {
  .invite-search {
    width: 343px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    margin: 16px auto 0;
    display: flex;
    align-items: center;
    padding: 0 6px 0 12px;

    input {
      display: inline-block;
      height: 100%;
      flex: 1;
      font-size: 16px;
      &::placeholder {
        font-family: HindMadurai;
        font-weight: 400;
        font-size: 13px;
        color: #cdcdd4;
      }
    }

    img {
      width: 18px;
      height: 18px;
      box-sizing: content-box;
      border: 6px solid transparent;
    }
  }

  .invite-card {
    width: 343px;
    min-height: 96px;
    margin: 16px auto 0;
    background: #3b1581;
    border-radius: 4px;
    overflow: hidden;
    padding: 20px 12px 12px;

    .card-info {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 17px;
      color: #ffffff;
      line-height: 20px;
      letter-spacing: -1px;
      img {
        display: inline-block;
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }
    }

    .card-bottom {
      display: flex;
      align-items: center;
      margin-top: 7px;
      .date-interval {
        flex: 1;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 16px;
      }
      .learn-more {
        width: 119px;
        height: 34px;
        background: #ff8a33;
        border-radius: 24px;

        font-family: RobotoFlex;
        font-weight: normal;
        font-size: 15px;
        color: #ffffff;
        line-height: 34px;
      }
    }
  }

  .invite-list {
    width: 343px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 auto;
    padding-bottom: 12px;
    margin-top: 16px;
  }

  .switch-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 12px;
    background-color: #ffffff;
    .tab {
      min-height: 26px;
      padding: 0 10px 4px;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 17px;
      color: #b2b2b2;
      line-height: 20px;
      text-align: center;

      &.active-tab {
        color: #333333;
        position: relative;
        font-weight: bold;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 35px;
          height: 2px;
          margin-left: -17.5px;
          background-color: #333333;
        }
      }
    }
  }

  .amount-block {
    overflow: hidden;
  }

  .amount-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    margin-top: 16px;
    .amount-title {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
    }
    .amount-count {
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #ff8a33;
      display: flex;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }

  .deliver-line {
    width: 343px;
    height: 1px;
    background: #ededed;
    margin-top: 16px;
  }

  .info-card {
    display: flex;
    padding: 16px 12px 12px;
    justify-content: space-between;
    .avatar-left {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }
    .info-right {
      flex: 1;
      margin-left: 10px;
      .text-row {
        display: flex;
        justify-content: space-between;
        .text-left {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          img {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            vertical-align: middle;
            margin-left: 4px;
          }
          .country-icon {
            border: 0.5px solid rgba(102, 102, 102, 0.1);
          }
        }
        .text-right {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
        }
      }
      .num-row {
        display: flex;
        justify-content: space-between;
        margin-top: 4px;
        font-family: RobotoFlex;
        font-weight: 400;
        font-size: 12px;
        color: #b2b2b2;
        .num-left {
          img {
            width: 12px;
            height: 12px;
            vertical-align: middle;
            margin-left: 4px;
          }
        }
      }
    }
  }

  .status-item {
    width: 319px;
    background: #f8f8ff;
    margin: 0 auto;
    position: relative;
    .status-card {
      display: flex;
      justify-content: space-around;
      border-radius: 4px;
      padding: 0 18px 12px;
      position: relative;
      .status-step {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 12px;
        border-radius: 8px;
        .step-icon {
          display: block;
          width: 36px;
          height: 36px;
          background-color: #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 22px;
            height: 22px;
            line-height: 36px;
          }
        }
        .status-icon {
          box-sizing: content-box;
          display: block;
          width: 16px;
          height: 16px;
          border: 4px solid transparent;
          margin: auto;
        }
        .beans-num {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 12px;
          color: #b2b2b2;
          margin-top: 6px;
          display: flex;
          align-items: center;
          img {
            width: 13px;
            height: 13px;
            margin-left: 2px;
          }
          &.highline {
            color: #ff8a33;
          }
          &.underline {
            text-decoration-line: line-through;
          }
        }
        &:first-child {
          flex: auto;
        }
      }
    }
    .status-line {
      width: 260px;
      height: 2px;
      background: #e7e7f6;
      border-radius: 1px;
      position: absolute;
      top: 29px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
    }
  }
  .newguy-guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    z-index: -999;

    .newguy-guide-btn {
      min-width: 72px;
      height: 30px;
      padding: 0 10px;
      border-radius: 20px;
      border: 1px solid #ffffff;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .newguy-guide-tips {
      width: 321px;
      background: #fdfdfd;
      border-radius: 8px;
      .tips-content {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 30px 22px;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -7px;
          z-index: -1;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          background: #fdfdfd;
          transform: rotate(45deg);
        }
        .tips-title {
          height: 40px;
          margin: 0 auto;
          font-family: RobotoFlex;
          font-weight: normal;
          font-size: 17px;
          color: #333333;
          line-height: 20px;
          text-align: center;
        }

        .tips-item {
          display: flex;
          align-items: center;

          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          margin-top: 16px;
          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
          }
        }
      }
    }

    .step1AndStep2 {
      position: absolute;
      bottom: 44px;
      right: 27px;

      .btn-wrap {
        text-align: right;
      }

      .newguy-guide-tips {
        margin-top: 20px;
      }

      .status-item {
        margin-top: 20px;
        border-radius: 8px;
      }
    }

    .step3 {
      position: absolute;
      bottom: 155px;
      right: 50%;
      transform: translateX(50%);

      .newguy-guide-tips {
        width: 280px;
        margin: 0 auto;

        .tips-content {
          padding: 12px 20px;
          .tips-title {
            height: auto;
            margin: 0 auto;
            font-size: 15px;
            text-align: left;
            letter-spacing: -1px;
          }
        }
      }

      .amount-block {
        border-radius: 8px;
        z-index: 9999;
        background: #fdfdfd;
        margin-top: 20px;
      }

      .btn-wrap {
        text-align: center;
        margin-top: 20px;
      }
    }
  }

  .is-loading {
    padding-top: 10px;
    text-align: center;
  }

  .no-more {
    padding-top: 10px;
    text-align: center;
    color: #b2b2b2;
    font-size: 16px;
  }
}

.ar-style {
  .amount-item {
    .amount-count {
      img {
        margin-right: 0;
        margin-left: 4px;
      }
    }
  }

  .info-card {
    .info-right {
      margin-left: 0;
      margin-right: 10px;
      .text-row {
        .text-left {
          img {
            margin-right: 4px !important;
            margin-left: 0 !important;
          }
        }
      }
      .num-row {
        .num-left {
          img {
            margin-left: 0;
            margin-right: 4px;
          }
        }
      }
    }
  }

  .newguy-guide-tips {
    .tips-item {
      img {
        margin-left: 10px;
        margin-right: auto;
      }
    }
  }
}
</style>

<style>
.invite-bean {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
.invite2-tips-wrapper {
  max-width: 220px;
  padding: 8px 10px;
}
</style>
